/* =============================================================================
   CATÁLOGO DE HABITACIONES · la página
   Arma #habCatalogo (página Habitaciones) a partir de habitaciones-data.js:
   filtros por tipo y, por cada tipo, una tarjeta (2026-10-30, mismo sistema que
   Inicio: Suite apaisada a todo el ancho y debajo cinco tarjetas, 3 + 2 en seis
   columnas) con su foto, su ficha (lo que decide: huéspedes, rasgos y cuántas
   hay; "Reservar" y "Fotos y detalles") y SUS habitaciones. Estas últimas se
   ven al elegir el tipo (filtro o botón «N habitaciones» de la tarjeta): cada
   una con su carrusel de fotos, sus rasgos y dos acciones: consultar por
   WhatsApp esa habitación en concreto o ver sus fotos en grande (el modal de
   siempre). La inclinación 3D de las tarjetas la pone inclinar.js (.rd-hab).

   Por qué agrupado por tipo y no una lista plana de ~20 habitaciones: el
   huésped elige primero el TIPO (cuántos son, cuánto espacio); recién
   después compara habitaciones. Agrupar evita el exceso de opciones y deja
   la página corta (una fila por tipo, las habitaciones se deslizan en
   horizontal).

   Corre ANTES que vines.js y app.js (orden de los <script defer>): la capa
   vegetal mide el documento y app.js engancha [data-page] y .rv-el al
   cargar, así que todo tiene que estar ya en el DOM. Los textos llevan
   data-i18n: i18n.js los vuelve a traducir solos al cambiar de idioma; lo
   que tiene números ({n}) se repinta aquí en 'i18n:change'.
   ============================================================================= */
(function () {
  var datos = window.LG_HABITACIONES;
  var raiz = document.getElementById('habCatalogo');
  if (!datos || !raiz) return;

  var WA = '51974330699';
  var R = '/assets/img/rooms/optim/';
  function t(k, fb) { var v = window.I18N ? window.I18N.t(k) : k; return v !== k ? v : (fb || ''); }
  // URL de Reservas en el idioma de la página, tomada del menú.
  var enlaceReservas = document.querySelector('a[data-page="reservas"][href^="/"]');
  var urlReservas = enlaceReservas ? enlaceReservas.getAttribute('href') : '/reservas/';
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function nombreUnidad(tipo, u, i) {
    return t('rooms.' + tipo.id + '.name', tipo.id) + ' ' + (u.numero || String(i + 1));
  }

  function waHref(nombre) {
    // Sin guiones opcionales (&shy;) de los nombres largos en el mensaje.
    return 'https://wa.me/' + WA + '?text=' + encodeURIComponent(t('modal.waMsg', '{room}').replace('{room}', nombre.replace(/\u00AD/g, '')));
  }
  var ICO_AMPLIAR = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M14 4h6v6M10 20H4v-6M20 4l-7 7M4 20l7-7" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICO_WA = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2c-1.6 0-3.1-.5-4.4-1.3l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.4.1-.6.3-.2.2-.8.8-.8 2s.9 2.4 1 2.5c.1.2 1.8 2.8 4.4 3.9 1.6.7 2.3.8 3.1.6.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.1-1.2l-.4-.2z"/></svg>';

  // Iconos de la fila de datos de cada tarjeta (los mismos de Inicio), por clave de texto.
  function ico(d) { return '<svg class="rd-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + d + '</svg>'; }
  var I_PERSONA = ico('<circle cx="12" cy="8" r="3.6"/><path d="M5 20c0-3.9 3.1-7 7-7s7 3.1 7 7"/>');
  var I_CAMA = ico('<path d="M3 18.5V6.5M3 14.5h18v4M21 14.5V12a2.5 2.5 0 0 0-2.5-2.5H11v5"/><circle cx="7" cy="11" r="1.7"/>');
  var I_SOFA = ico('<path d="M5 11V8a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v3"/><path d="M3 13a2 2 0 0 1 4 0v2h10v-2a2 2 0 0 1 4 0v5H3z"/><path d="M5 18v2M19 18v2"/>');
  var I_HOJA = ico('<path d="M12 21V12"/><path d="M12 14c-5 0-7.5-3-7.5-7.5C9.5 6.5 12 9.5 12 14z"/><path d="M12 17c4.5 0 7-2.5 7-6.5-4.5 0-7 2.5-7 6.5z"/>');
  var I_TINA = ico('<path d="M3 12h18v2a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5z"/><path d="M6 12V6.5A2.5 2.5 0 0 1 10.5 5"/><path d="M7 19l-1 2M17 19l1 2"/>');
  var ICO_DATO = {
    'rasgo.jacuzzi': I_TINA,
    'rd.habitaciones.dato.salaEstar': I_SOFA, 'rd.habitaciones.dato.areaEstar': I_SOFA,
    'rd.habitaciones.dato.accesoJardin': I_HOJA, 'rasgo.jardin': I_HOJA,
    'rd.habitaciones.dato.camaKing': I_CAMA, 'rd.habitaciones.dato.tresCamas': I_CAMA, 'rd.habitaciones.dato.dosCamas': I_CAMA
  };
  var ICO_FLECHA = '<svg class="hab-tipo-n-flecha" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12h14M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var total = datos.reduce(function (n, tp) { return n + tp.unidades.length; }, 0);

  /* ── Marcado ─────────────────────────────────────────────────────────────── */
  // Rediseño 2026-10-29 («la gruta = el nicho»): cada tipo es una composición
  // propia sobre la rejilla de 12 columnas: su foto grande (vertical en arco u
  // horizontal recta, a un lado y al otro, alternando), su ficha y la tira de
  // sus habitaciones, que se desliza en horizontal (scroll-snap). Las clases
  // .hab-tipo--arco|--h y --izq|--der eligen la disposición (rd-habitaciones.css).
  var html = [];
  // La nota (.hab-nota) vive en el HTML, junto al título del catálogo y fuera
  // del encabezado fijo: se lee una vez y se ve también sin JS.
  html.push('<div class="hab-top">');
  html.push('<p class="hab-total" data-hab-total></p>');
  html.push('<div class="hab-filtros" role="group" data-i18n-attr="aria-label:hab.filtro.label" aria-label="' + esc(t('hab.filtro.label')) + '">');
  html.push('<button type="button" class="hab-filtro" data-filtro="" aria-pressed="true" data-i18n="hab.filtro.todas">' + esc(t('hab.filtro.todas', 'Todas')) + '</button>');
  datos.forEach(function (tp) {
    html.push('<button type="button" class="hab-filtro" data-filtro="' + tp.id + '" aria-pressed="false" data-i18n="rooms.' + tp.id + '.name">' + esc(t('rooms.' + tp.id + '.name', tp.id)) + '</button>');
  });
  html.push('</div>');
  html.push('</div>');

  html.push('<div class="hab-pila">');
  datos.forEach(function (tp, n) {
    // Galería del tipo (modal de "Ver más"): las portadas de todas sus
    // habitaciones y luego su segunda foto. Con ~5 habitaciones por tipo, sumar
    // todas las fotos daría un carrusel de 15; cada habitación ya tiene el suyo.
    var todas = [];
    [0, 1].forEach(function (k) {
      tp.unidades.forEach(function (u) { if (u.fotos[k] && todas.indexOf(u.fotos[k]) === -1) todas.push(u.fotos[k]); });
    });
    var nombreTipo = t('rooms.' + tp.id + '.name', tp.id);
    // Foto de la tarjeta (4:3, apaisada): la portada del tipo si es horizontal;
    // si es vertical, la foto principal de su primera habitación (también horizontal).
    var p = tp.portada || { numero: tp.unidades[0].numero, sufijo: '', forma: 'h' };
    var enMarco = p.forma === 'h' ? { numero: p.numero, src: R + p.numero + p.sufijo + '.webp' } : { numero: tp.unidades[0].numero, src: tp.unidades[0].fotos[0] };
    html.push('<article class="hab-tipo" data-tipo="' + tp.id + '" aria-labelledby="hab-t-' + tp.id + '">');
    html.push('<div class="rd-hab"><div class="rd-hab-inc">');

    // Foto del tipo: una de sus habitaciones (el alt dice cuál).
    html.push('<div class="rd-hab-foto"><img src="' + esc(enMarco.src) + '" alt="' + esc(nombreTipo + ' ' + enMarco.numero) + '" data-portada="' + esc(enMarco.numero) + '" data-ph="' + esc(nombreTipo + ' ' + enMarco.numero) + '" width="1448" height="1086" loading="lazy" decoding="async"></div>');
    html.push('<div class="rd-hab-cuerpo">');

    // Ficha del tipo. Es una .room-card con data-detail-key: así la encuentra
    // el modal (y el "Ver más" de las tarjetas del Inicio).
    html.push('<div class="hab-tipo-info room-card" data-detail-key="rooms.' + tp.id + '.detail"' +
      (tp.huespedes ? ' data-guests="' + tp.huespedes + '"' : '') + ' data-images="' + esc(todas.join(',')) + '">');
    html.push('<h3 class="hab-tipo-name room-card-name" id="hab-t-' + tp.id + '" data-i18n="rooms.' + tp.id + '.name">' + esc(nombreTipo) + '</h3>');
    html.push('<p class="hab-tipo-desc room-card-desc" data-i18n="rooms.' + tp.id + '.descShort">' + esc(t('rooms.' + tp.id + '.descShort')) + '</p>');
    // Lo que decide la elección, en texto simple: huéspedes, rasgos, cuántas hay.
    html.push('<ul class="hab-tipo-datos">');
    if (tp.huespedes) {
      var kg = 'avail.guest' + Math.min(tp.huespedes, 4);
      html.push('<li class="hab-tipo-cap">' + I_PERSONA + '<span data-i18n="' + kg + '">' + esc(t(kg)) + '</span></li>');
    }
    (tp.destacados || []).forEach(function (k) {
      html.push('<li>' + (ICO_DATO[k] || '') + '<span data-i18n="' + esc(k) + '">' + esc(t(k, '')) + '</span></li>');
    });
    // «N habitaciones»: lleva a las habitaciones de este tipo (filtra el catálogo).
    html.push('<li class="hab-tipo-ver"><button type="button" class="hab-tipo-n" data-ir="' + tp.id + '"><span data-hab-n="' + tp.unidades.length + '"></span>' + ICO_FLECHA + '</button></li>');
    html.push('</ul>');
    // «Reservar» usa la URL de Reservas del menú, que ya está en el idioma de
    // la página (/reservas/, /en/booking/…). «Fotos y detalles» abre el modal
    // (app.js); su href es la propia página para poder abrirlo o copiarlo.
    html.push('<div class="room-card-actions"><a href="' + esc(urlReservas) + '" class="rc-book rd-btn" data-page="reservas" data-i18n="rd.inicio.hab.reserva">' + esc(t('rd.inicio.hab.reserva', 'Reserva rápida')) +
      '</a><a href="' + esc(location.pathname) + '" class="rc-more room-more rd-link" data-i18n="rd.habitaciones.verMas">' + esc(t('rd.habitaciones.verMas', 'Fotos y detalles')) + '</a></div>');
    html.push('</div></div></div></div>');

    // Sus habitaciones.
    html.push('<ul class="hab-unidades" data-n="' + tp.unidades.length + '">');
    tp.unidades.forEach(function (u, i) {
      var nombre = nombreUnidad(tp, u, i);
      var num = esc(u.numero || String(i + 1));
      html.push('<li class="hab-unidad" data-detail-key="rooms.' + tp.id + '.detail"' + (tp.huespedes ? ' data-guests="' + tp.huespedes + '"' : '') + ' data-tipo="' + tp.id + '" data-numero="' + num + '">');
      html.push('<div class="room-card-media hab-media">');
      html.push('<img class="imgc" src="' + esc(u.fotos[0]) + '" data-images="' + esc(u.fotos.join(',')) + '" data-ph="' + esc(nombre) + '" alt="" loading="lazy" decoding="async">');
      if (u.fotos.length > 1) {
        html.push('<button type="button" class="hab-flecha" data-dir="-1" data-i18n-attr="aria-label:modal.prevPhoto" aria-label="' + esc(t('modal.prevPhoto')) + '">←</button>');
        html.push('<button type="button" class="hab-flecha" data-dir="1" data-i18n-attr="aria-label:modal.nextPhoto" aria-label="' + esc(t('modal.nextPhoto')) + '">→</button>');
      }
      // La foto es la puerta a la galería: el chip «⤢ 1 / 5» (y la foto misma)
      // abre el modal de ESTA habitación en la foto que se ve.
      html.push('<button type="button" class="hab-ver hab-contador" data-nombre="' + esc(nombre) + '">' + ICO_AMPLIAR +
        '<span class="hab-cuenta">1 / ' + u.fotos.length + '</span><span class="sr-only" data-hab-ver-label></span></button>');
      html.push('</div>');
      html.push('<div class="hab-unidad-body">');
      // Nombre, lo que la distingue (rasgos) y sus dos acciones en texto:
      // «Consultar» (WhatsApp con su nombre) y «Ver fotos» (la galería).
      html.push('<h4 class="hab-unidad-name room-card-name"><span data-i18n="rooms.' + tp.id + '.name">' + esc(nombreTipo) + '</span> ' + num + '</h4>');
      if (u.rasgos && u.rasgos.length) {
        html.push('<ul class="hab-rasgos room-card-desc">');
        u.rasgos.forEach(function (r) { html.push('<li data-i18n="rasgo.' + r + '">' + esc(t('rasgo.' + r, r)) + '</li>'); });
        html.push('</ul>');
      }
      html.push('<div class="hab-unidad-cab">' +
        '<a class="hab-wa" href="' + esc(waHref(nombre)) + '" target="_blank" rel="noopener">' + ICO_WA +
        '<span class="hab-wa-txt" data-i18n="hab.consultar">' + esc(t('hab.consultar', 'Consultar')) + '</span><span class="sr-only"> ' + esc(nombre) + '</span></a>' +
        '<button type="button" class="hab-fotos">' + ICO_AMPLIAR + '<span data-i18n="hab.verFotos">' + esc(t('hab.verFotos', 'Ver fotos')) + '</span></button>' +
        '</div>');
      // Pie de la tarjeta: queda para el precio (hoy solo lo usa ?demo=pagos).
      html.push('<div class="hab-unidad-acciones"></div>');
      html.push('</div></li>');
    });
    html.push('</ul></article>');
  });
  html.push('</div>');
  raiz.innerHTML = html.join('');

  /* ── Textos con números y enlaces que dependen del idioma ─────────────────── */
  function repintar() {
    var tot = raiz.querySelector('[data-hab-total]');
    if (tot) tot.textContent = t('hab.total', '{n}').replace('{n}', total).replace('{t}', datos.length);
    raiz.querySelectorAll('[data-hab-n]').forEach(function (el) {
      el.textContent = t('hab.unidades', '{n}').replace('{n}', el.dataset.habN);
    });
    raiz.querySelectorAll('[data-portada]').forEach(function (img) {
      img.alt = t('rooms.' + img.closest('.hab-tipo').dataset.tipo + '.name') + ' ' + img.dataset.portada;
    });
    raiz.querySelectorAll('.hab-unidad').forEach(function (li) {
      var tp = datos.filter(function (x) { return x.id === li.dataset.tipo; })[0];
      var nombre = t('rooms.' + tp.id + '.name', tp.id) + ' ' + li.dataset.numero;
      li.querySelector('.hab-wa').href = waHref(nombre);
      li.querySelector('.hab-wa .sr-only').textContent = ' ' + nombre;
      li.querySelector('[data-hab-ver-label]').textContent = ' · ' + t('hab.verFotos', 'Ver fotos') + ' ' + nombre;
    });
  }
  repintar();
  document.addEventListener('i18n:change', repintar);

  /* ── Filtros por tipo ────────────────────────────────────────────────────── */
  // «Todas»: las seis tarjetas (Suite apaisada y cinco debajo). Un tipo: su
  // tarjeta, a todo el ancho, y debajo SUS habitaciones (clase hab-pila--uno).
  // El cambio es un fundido corto (sale y entra); con movimiento reducido, directo.
  var pila = raiz.querySelector('.hab-pila');
  var pendiente = 0;
  function sinMovimiento() {
    return matchMedia('(prefers-reduced-motion: reduce)').matches || document.documentElement.classList.contains('ligero');
  }
  function filtrar(f, subir) {
    raiz.querySelectorAll('.hab-filtro').forEach(function (x) { x.setAttribute('aria-pressed', x.dataset.filtro === f ? 'true' : 'false'); });
    function aplicar() {
      pendiente = 0;
      raiz.querySelectorAll('.hab-tipo').forEach(function (s) { s.hidden = !!f && s.dataset.tipo !== f; });
      pila.classList.toggle('hab-pila--uno', !!f);
      // La capa vegetal y las transiciones miden el documento: su alto cambió.
      window.dispatchEvent(new Event('resize'));
      // Con el catálogo ya recorrido (o al venir de una tarjeta), volver a su inicio:
      // ocultar tarjetas no debe dejar al visitante mirando el pie.
      var head = raiz.querySelector('.hab-top');
      var nav = document.getElementById('nav');
      var meta = head.getBoundingClientRect().top + window.scrollY - (nav ? nav.offsetHeight : 0) - 16;
      if (subir || window.scrollY > meta) window.scrollTo({ top: Math.max(0, meta), behavior: 'instant' });
      requestAnimationFrame(function () { pila.classList.remove('hab-pila--sale'); });
    }
    if (pendiente) { clearTimeout(pendiente); pendiente = 0; }
    if (sinMovimiento()) { aplicar(); return; }
    pila.classList.add('hab-pila--sale');
    pendiente = setTimeout(aplicar, 130);
  }
  raiz.addEventListener('click', function (e) {
    var b = e.target.closest('.hab-filtro');
    if (b) { filtrar(b.dataset.filtro, false); return; }
    var ir = e.target.closest('.hab-tipo-n');
    if (ir) filtrar(ir.dataset.ir, true);
  });

  /* ── Carrusel de cada habitación: flechas y deslizar con el dedo ─────────── */
  function mover(media, dir) {
    var img = media.querySelector('img');
    var lista = (img.dataset.images || '').split(',');
    if (lista.length < 2) return;
    // data-cur: el destino, incluso mientras carga o queda en cola durante
    // el fundido editorial; los clics seguidos cuentan desde ese índice.
    var i = img.dataset.cur !== undefined ? Number(img.dataset.cur) : Math.max(0, lista.indexOf(img.getAttribute('src')));
    i = ((i + dir) % lista.length + lista.length) % lista.length;
    img.dataset.cur = i;
    if (window.FotoFundido) window.FotoFundido.cambiar(img, lista[i]);
    else img.src = lista[i];
    var c = media.querySelector('.hab-cuenta');
    if (c) c.textContent = (i + 1) + ' / ' + lista.length;
  }
  raiz.addEventListener('click', function (e) {
    var b = e.target.closest('.hab-flecha');
    if (b) mover(b.closest('.hab-media'), Number(b.dataset.dir));
  });
  var x0 = null;
  raiz.addEventListener('touchstart', function (e) {
    if (e.target.closest('.hab-media')) x0 = e.touches[0].clientX;
  }, { passive: true });
  raiz.addEventListener('touchend', function (e) {
    var m = e.target.closest('.hab-media');
    if (!m || x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0;
    x0 = null;
    if (Math.abs(dx) > 40) mover(m, dx < 0 ? 1 : -1);
  }, { passive: true });
})();
